import React, { forwardRef } from 'react';
import { motion } from 'framer-motion';
import { cn } from '../../utils/cn';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  fullWidth?: boolean;
  href?: string;
}
const variants = {
  primary: 'bg-pistachio-400 text-pistachio-900 hover:bg-pistachio-300 shadow-[0_8px_20px_-8px_rgba(104,143,58,0.55)]',
  secondary: 'bg-surface text-pistachio-700 border border-pistachio-300 hover:bg-pistachio-50',
  outline: 'border-2 border-pistachio-500 text-pistachio-700 hover:bg-pistachio-100'
};
const sizes = {
  sm: 'h-9 px-5 text-xs',
  md: 'h-11 px-7 text-sm',
  lg: 'h-14 px-8 text-base',
  xl: 'h-16 px-10 text-base sm:text-lg'
};
export const Button = forwardRef<HTMLButtonElement, ButtonProps>(({
  className,
  variant = 'primary',
  size = 'md',
  fullWidth,
  href,
  children,
  ...props
}, ref) => {
  const classes = cn('inline-flex items-center justify-center text-center rounded-xl font-semibold leading-tight transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-pistachio-600 focus-visible:ring-offset-2 focus-visible:ring-offset-canvas disabled:opacity-50 disabled:pointer-events-none', variants[variant], sizes[size], fullWidth && 'w-full', className);
  const content = <motion.button ref={ref} className={classes} whileHover={{
    scale: 1.02,
    y: -2
  }} whileTap={{
    scale: 0.98
  }} {...props} data-id="element-343" data-mp="12mtlla27sm3k">
        {children}
      </motion.button>;
  if (href) {
    return <a href={href} className={cn('focus-visible:outline-none', fullWidth && 'w-full block')} data-id="element-344" data-mp="1cfhlidohr66i">
          {content}
        </a>;
  }
  return content;
});
Button.displayName = 'Button';